import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { StyledRoundel, StyledNectarRoundel } from './Roundel.styles'
import { RoundelProps } from './types'

const Roundel = ({
  component = '',
  roundel = { type: 'new' },
  backgroundColor = ''
}: RoundelProps): React.ReactElement => {
  const theme = useContext(ThemeContext)
  const svgRoundel = () => {
    if (roundel?.type === 'nectar') {
      return <StyledNectarRoundel component={component} data-test={`${component}-nectar-roundel`} />
    }
    return (
      <StyledRoundel
        text={roundel?.type.charAt(0).toUpperCase() + roundel.type.slice(1)}
        backgroundColor={backgroundColor}
        textColor={theme.color.monochrome.white}
        component={component}
        data-test={`${component}-roundel`}
      />
    )
  }

  return svgRoundel()
}

export default Roundel
